import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as DatePickerWrapper } from "@mui/x-date-pickers/DatePicker";
import moment, { Moment } from "moment";

type DatePickerPropsType = {
  name?: string;
  label?: string | undefined;
  value?: Moment | null | undefined | any;
  onChangeCb?: (value: Moment | null) => void;
  style?: Record<string, string>;
  error?: boolean;
  helperText?: string;
  isStarPresent?: boolean;
  minDate?: any;
  maxDate?: any;
  disabled?: boolean;
  // Value should come like below in moment
  // maxDate={moment("11/13/2024", "MM/DD/YYYY")}
  // minDate={moment("11/11/2024", "MM/DD/YYYY")}

  onBlur?: (e: any) => any;
};

export default function DatePicker({
  name,
  label,
  value,
  onChangeCb = () => {
    /* no-op */
  },
  disabled = false,
  style = {},
  error = false,
  helperText,
  isStarPresent = false,
  maxDate,
  minDate,
  onBlur = (e) => {},
}: DatePickerPropsType) {
  let dateValue = value;

  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;

  if (dateRegex.test(value)) {
    dateValue = moment(dateValue, "MM/DD/YYYY");
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePickerWrapper
        name={name}
        label={
          <>
            {label}{" "}
            {isStarPresent && <span style={{ color: "#CE0718" }}>*</span>}
          </>
        }
        disabled={disabled}
        value={dateValue}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            error: error,
            helperText: helperText,
            onBlur: onBlur,
          },
        }}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChangeCb}
        sx={style}
      />
    </LocalizationProvider>
  );
}
